import { call, put, takeLatest } from 'redux-saga/effects';
import {
	RecentClientsActionTypes,
	RecentClientsTryGetResultsAction,
} from '../../store/actions/recent-clients.actions';
import { getRecentClients } from '../functions/recentClients.function';

export function* getRecentClientsSaga() {
	yield takeLatest(
		RecentClientsActionTypes.RECENT_CLIENTS_RESULTS_GET,
		getRecentClientsResults
	);
}

export function* getRecentClientsResults(
	action: RecentClientsTryGetResultsAction
) {
	yield put({
		type: RecentClientsActionTypes.RECENT_CLIENTS_RESULTS_LOADING,
	});
	try {
		const response = yield call(() => getRecentClients(action.adviserUUID));
		yield put({
			type: RecentClientsActionTypes.RECENT_CLIENTS_RESULTS_SUCCESS,
			response,
		});
	} catch (Error) {
		yield put({
			type: RecentClientsActionTypes.RECENT_CLIENTS_RESULTS_FAILURE,
			Error,
		});
	}
}
